import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import MyBusinessView from '@/views/MyBusinessView.vue'
import SearchSettingsView from '@/views/SearchSettingsView.vue'
import SearchCustomizationView from '@/views/SearchCustomizationView.vue'
import PersonaliseView from '@/views/PersonaliseView.vue'
import DemoView from '@/views/demos/DemoView.vue'
import CreateDemoView from '@/views/demos/CreateDemoView.vue'
import MySearchView from '@/views/MySearchView.vue'
import SearchesView from '@/views/SearchesView.vue'
import FAQsView from '@/views/FAQsView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/my-business',
    name: 'MyBusiness',
    component: MyBusinessView,
    meta: { requiresAuth: true }
  },
  {
    path: '/search-settings',
    name: 'SearchSettings',
    component: SearchSettingsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: () => import('@/views/AnalyticsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/search-customization',
    name: 'search-customization',
    component: SearchCustomizationView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/personalise',
    name: 'personalise',
    component: PersonaliseView
  },
  {
    path: '/my-search',
    name: 'MySearch',
    component: MySearchView,
    meta: { requiresAuth: true }
  },
  {
    path: '/searches',
    name: 'Searches',
    component: SearchesView,
    meta: { requiresAuth: true }
  },
  {
    path: '/faqs',
    name: 'FAQs',
    component: FAQsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/demos/:id',
    name: 'Demo',
    component: DemoView,
    meta: { requiresAuth: false }
  },
  {
    path: '/demo/create',
    name: 'CreateDemo',
    component: CreateDemoView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // Initialize auth store if not already initialized
  await authStore.init()

  // If still loading, allow the navigation and let the component handle the loading state
  if (authStore.loading) {
    return next()
  }

  if (requiresAuth && !authStore.user) {
    return next('/login')
  } else if (!requiresAuth && authStore.user && (to.path === '/login' || to.path === '/register')) {
    return next('/')
  } else {
    return next()
  }
})

export default router
